import React from 'react';
import { useController } from '../../workspace/useWorkspace.jsx';
import StandaloneLayout from './BrandedLayout.jsx';

function standaloneAppProps(props) {
  const defaults = {
    functionType: '',
    defaultSessionTitle: '',
    projectId: '',
    userId: '',
    backendMode: '',
    kernelBaseUrl: '',
    apiBaseUrl: '',
    apiToken: '',
    defaultProjectName: '',
    instanceId: '',
    domainPackDomain: '',
    domainPackVersion: '',
    branding: {},
    instanceProfile: null,
    uiLabels: {},
    displayPolicy: {},
    starterScenarios: [],
    composerModeOptions: [],
    capabilityCatalog: [],
    modulePromptRegistry: [],
  };
  return {
    ...props,
    ...Object.fromEntries(Object.entries(defaults).map(([key, fallback]) => [
      key, props[key] === undefined ? fallback : props[key],
    ])),
  };
}

export default function StandaloneChatApp(props = {}) {
  const {
    functionType,
    defaultSessionTitle,
    projectId,
    userId,
    backendMode,
    kernelBaseUrl,
    apiBaseUrl,
    apiToken,
    defaultProjectName,
    instanceId,
    domainPackDomain,
    domainPackVersion,
    branding,
    instanceProfile,
    uiLabels,
    displayPolicy,
    devToolbar = {},
    starterScenarios,
    composerModeOptions,
    capabilityCatalog,
    modulePromptRegistry,
  } = standaloneAppProps(props);
  const controllerModel = useController({
    functionType,
    defaultSessionTitle,
    projectId,
    userId,
    backendMode,
    kernelBaseUrl,
    apiBaseUrl,
    apiToken,
    defaultProjectName,
    instanceId,
    domainPackDomain,
    domainPackVersion,
    branding,
    uiLabels,
    displayPolicy,
    starterScenarios,
    composerModeOptions,
    capabilityCatalog,
    modulePromptRegistry,
  });

  return (
    <StandaloneLayout
      {...controllerModel}
      devToolbarConfig={{
        ...devToolbar,
        apiBaseUrl,
        backendMode,
        domainPackDomain,
        domainPackVersion,
        instanceId,
        kernelBaseUrl,
        userId,
      }}
      initialInstanceProfile={instanceProfile}
    />
  );
}
